// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__RntAA","pagination":"style_pagination__ZVgPm"};